import React, {Component} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {Input, Button, CircularProgress} from '@material-ui/core';
import {Edit, Save, Check, Close} from '@material-ui/icons';

//button states
const EDITING = 'editing';
const SUBMITTING = 'submitting';
const SUCCESS = 'success';
const ERROR = 'error';
const DEFAULT = 'default';

class ToggleEditField extends Component {
  inputRef = React.createRef();

  state = {
    text: this.props.value,
    inputState: DEFAULT,
    avoidExternalFocus: this.props.avoidExternalFocus ?? false, //Variabile che, se settata, evita che il click all'esterno dell'input triggeri il salvataggio
  };

  componentDidUpdate() {
    if (this.state.inputState === EDITING) {
      this.inputRef.current.focus();
    }
  }

  onUpdate = async () => {
    if (this.props.value === this.state.text) {
      this.setState({inputState: DEFAULT});
      return;
    }

    this.setState({inputState: SUBMITTING});

    try {
      await this.props.updateValue(this.state.text);

      this.setState({inputState: SUCCESS});

      setTimeout(() => {
        this.setState({inputState: DEFAULT});
      }, 3000);
    } catch {
      this.setState({inputState: ERROR, text: this.props.value});

      setTimeout(() => {
        this.setState({inputState: DEFAULT});
      }, 3000);
    }
  };

  getButtonPropsFromState = () => {
    // Rebranding 2026 · icona antracite (no MUI secondary blu), background palette ivory
    const iconProps = {
      fontSize: 'small',
      style: {color: '#1F2125'},
    };

    const {inputState} = this.state;

    if (inputState === ERROR) {
      return {
        icon: <Close {...iconProps} style={{color: '#B0463C'}} />,
        style: {background: '#F9E9E5', border: '1px solid #F0CFC8'},
      };
    }

    if (inputState === SUCCESS) {
      return {
        icon: <Check {...iconProps} style={{color: '#3B8B6A'}} />,
        style: {background: '#E8F2EC', border: '1px solid #CFE6DA'},
      };
    }

    if (inputState === SUBMITTING) {
      return {icon: <Spinner />, disabled: true, style: {background: '#F4ECD8', border: '1px solid #F1E4C4'}};
    }

    if (inputState === EDITING) {
      let saveIcon = {
        icon: <Save {...iconProps} />,
        style: {background: '#C9A961', border: '1px solid #A88845'},
      };
      if(this.state.avoidExternalFocus){
        //L'icona deve funzionare come pulsante e solo al click del pulsante effettua la chiamate
        saveIcon.onClick = () => this.onUpdate();
      }
      return saveIcon;
    }

    return {
      icon: <Edit {...iconProps} />,
      style: {background: '#FAF4E6', border: '1px solid #F1E4C4'},
      onClick: () => this.setState({inputState: EDITING}),
    };
  };

  render() {
    const {icon, ...buttonProps} = this.getButtonPropsFromState();
    const isEditing = this.state.inputState === EDITING;
    return (
      <Row>
        <IconButton {...buttonProps}>{icon}</IconButton>
        <Input
          value={this.state.text}
          onChange={evt => this.setState({text: evt.target.value})}
          inputProps={{ref: this.inputRef}}
          readOnly={!isEditing}
          disableUnderline={!isEditing}
          onBlur={() => !this.state.avoidExternalFocus && isEditing && this.onUpdate()}
          style={{fontSize: 14}}
          fullWidth
          multiline
        />
      </Row>
    );
  }
}

export default ToggleEditField;

ToggleEditField.propTypes = {
  value: PropTypes.string,
  updateValue: PropTypes.func.isRequired,
};

const Row = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

const IconButton = styled(Button).attrs({
  variant: 'contained',
  disableElevation: true,
  className: 'gc-edit-toggle',
})`
  /* Rebranding 2026 · box 40x40 sempre, palette Ivory, no shadow MUI */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  min-width: 40px;
  padding: 0;
  margin: 0 8px 0 0;
  border-radius: 8px;
  box-shadow: none;
  transition: transform 100ms ease, box-shadow 200ms ease;

  &:hover {
    box-shadow: 0 2px 6px rgba(31,33,37,0.08);
    transform: translateY(-1px);
  }
  &:active { transform: translateY(0); }
`;

const Spinner = styled(CircularProgress).attrs({
  size: 16,
})`
  color: var(--gc-antracite, #1F2125);
`;
